export default __webpack_public_path__ + "static/media/review6.553d9c98.jpg";